
import React, { useState } from 'react';
import Button from '../base/Button';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-2xl font-bold">
              <a href="/" className="flex items-center space-x-2">
                <span className="text-orange-500 font-bold text-3xl">POG</span>
                <span className="text-blue-600 font-semibold">Professional Office Group</span>
              </a>
            </h1>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center">
            <Button variant="primary" size="sm" href="/quote">
              Get Free Quote
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-blue-600 p-2"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="flex flex-col space-y-4">
              <Button variant="primary" size="sm" href="/quote" className="w-fit">
                Get Free Quote
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
